import { render, staticRenderFns } from "./RetirementPension.vue?vue&type=template&id=4614da52&scoped=true&"
import script from "./RetirementPension.vue?vue&type=script&lang=js&"
export * from "./RetirementPension.vue?vue&type=script&lang=js&"
import style0 from "./RetirementPension.vue?vue&type=style&index=0&id=4614da52&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4614da52",
  null
  
)

export default component.exports